// eslint-disable-next-line @nx/enforce-module-boundaries
import { useQuery } from '@occc-app/dataAccessLayer/utils';
import { useCustomerScanDataOverviewQuery } from '@occc/graphql';

export const useCustomerScanDataOverview = () => {
  return useQuery(useCustomerScanDataOverviewQuery);
};
